
import tippy from 'tippy.js';
import urlJoin from 'url-join';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/material.css';
import 'tippy.js/animations/scale.css';
import classNames from 'classnames';
import { getInfoIconHtml } from '../../../../includes/assets/js/modules/dpitUtilsInc';

export default class AdminSetupTippy {

	constructor(config) {
		if (config.dpDebugEn) console.log('[dpit] INIT AdminSetupTippy');
		this.config = config;
		this.init();
	}

	init = () => {

		$('.dpit-settings__el__hint').each((idx, element) => {
			const jHintEl = $(element);
			const jTdElement = jHintEl.closest('td');
			const proOnly = jTdElement.find('.dpit-settings__el').hasClass('dpit-pro-only');
			const title = jHintEl.closest('tr').find('th').text();
			let text = jHintEl.html() || '';
			if (text.length) {
				const iconClasses = classNames({
					['dpit-info-icon']: true,
					['dpit-info-icon--inline']: true,
					['dpit-info-icon--bigger']: true,
					['dpit-info-icon--settings']: true,
					['dpit-info-icon--pro-only']: proOnly
				});
				jTdElement.addClass('dpit-settings--with-info-icon').append(getInfoIconHtml(iconClasses, text, title));
				jHintEl.fadeOut(300, () => {
					$('.dpit-info-icon').each((idx, element) => {
						tippy(element, {
							content: (reference) => reference.getAttribute('data-info-text'),
							animation: 'scale',
							theme: 'material',
							allowHTML: true,
							interactive: true
						});
					});
					$('.dpit-info-icon').load(urlJoin(this.config.assetsUrl, '../../includes/assets/icons/info-circle-solid.svg'), () => {
						$('.dpit-info-icon').fadeIn(700);
					});
				});
			}
		});
	};
}